import * as I18n from 'i18n-js';
import * as React from 'react';
import { IComponentProps } from './suggestion';
import lowlight from './lowlight';
import SanitizedRender from '@reverbdotcom/commons/dist/components/sanitized_render';

import bind from '@reverbdotcom/commons/dist/bind';

const classNames = require('classnames');

export default class SiteSearchSuggestion extends React.Component<IComponentProps, null> {
  public displayName = 'SiteSearchSuggestion';

  public static defaultProps: Partial<IComponentProps> = {
    lastTypedValue: '',
  };

  @bind
  submitSelection(e): void {
    e.preventDefault();

    this.props.selectSuggestion(this.props.suggestion);
  }

  renderContext() {
    if (!this.props.suggestion.context) { return null; }

    return (
      <small>{I18n.t('discovery.searchBar.in')} {this.props.suggestion.context}</small>
    );
  }

  renderValue() {
    return lowlight({
      input: this.props.lastTypedValue,
      output: this.props.suggestion.value,
      emphasize: (_, em) => `${em.pre}<b>${em.word}</b>${em.post}`,
      noop: (_, em) => em.word,
    }).join(' ');
  }

  render() {
    const classes = classNames(
      'site-search__dropdown__section__item',
      { 'site-search__dropdown__section__item--selected': this.props.active },
    );

    return (
      <div
        className={classes}
      >
        <a onClick={this.submitSelection}>
          <SanitizedRender html={this.renderValue()} />
          {this.renderContext()}
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/site_search/site_search_suggestion.tsx